import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './ui/App'
import { AuthProvider } from './auth/AuthProvider'
import { AuthGate } from './auth/AuthGate'
import { ToastProvider } from './components/Toast'

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // When a new SW takes control, reload to apply fresh assets immediately
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Avoid infinite loops
        if (!(window as any).__reloaded_for_sw__) {
          (window as any).__reloaded_for_sw__ = true
          window.location.reload()
        }
      })
      // Optional: if an update is found, tell the installing worker to activate now
      if (reg.waiting) reg.waiting.postMessage?.({ type: 'SKIP_WAITING' })
      reg.addEventListener('updatefound', () => {
        const sw = reg.installing
        if (!sw) return
        sw.addEventListener('statechange', () => {
          if (sw.state === 'installed' && navigator.serviceWorker.controller) {
            sw.postMessage?.({ type: 'SKIP_WAITING' })
          }
        })
      })
    }).catch(() => {})
  })
}

const root = createRoot(document.getElementById('root')!)
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AuthGate>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AuthGate>
    </AuthProvider>
  </React.StrictMode>
)
